"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const userQuery_1 = require("../../../../queries/userQuery");
const zustandStore_1 = require("../../../../zustandStore");
const simpleHeader_1 = __importDefault(require("../../../organisms/header/simpleHeader"));
const teams_1 = __importDefault(require("../../../templates/companySettings/teams"));
const CompanySettingsTeamsPage = () => {
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: userData } = (0, react_query_1.useQuery)({
        ...(0, userQuery_1.getUserQuery)(),
        initialData: initialData.user,
    });
    const { setUser, setCompanyName, setCompanyId, setHeaderName } = (0, zustandStore_1.useZustand)();
    (0, react_1.useEffect)(() => {
        if (userData) {
            setUser(userData);
            setCompanyName(userData.companyName);
            setCompanyId(userData.companyAccountId);
            setHeaderName(userData.companyName);
        }
    }, [setCompanyId, setCompanyName, setHeaderName, setUser, userData]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleHeader_1.default, {}), (0, jsx_runtime_1.jsx)(teams_1.default, {})] }));
};
exports.default = CompanySettingsTeamsPage;
